export const defaultValues = {
  email: '',
  password: '',
  remember: true,
};

export enum statusEnum {
  SUCCESS = 1000,
  ERROR = 2001,
}
